import { memo } from 'react';

const ContainerHeader = ({ children, ...props }) => {
    return (
        <div className='stickysidemenu-header'>
            {children}
        </div>
    );
}

export default memo(ContainerHeader);